"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _NavLink = _interopRequireDefault(require("../NavLink"));
var _user = _interopRequireDefault(require("cccisd-icons/user3"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left6"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false
    });
    _defineProperty(_this, "returnToUser", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              e && e.preventDefault();
              _this.setState({
                loading: true
              });
              _context.n = 1;
              return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.user.logoutAs'));
            case 1:
              window.location.href = Boilerplate.url(Fortress.settings.config.after_login_url);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "changeRole", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(pawnId, e) {
        var response, redirectUrl;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              e && e.preventDefault();
              if (!(pawnId === Fortress.user.pawnId)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this.setState({
                loading: true
              });
              _context2.n = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.user.changeTo'), {
                pawn: pawnId
              });
            case 2:
              response = _context2.v;
              if (!(response.status !== 200 || !response.data.data)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              redirectUrl = Boilerplate.url(Fortress.settings.config.after_login_url);
              if (response.data.data.hasIncompleteSiteRegistration) {
                redirectUrl = Boilerplate.url('/account/registrationSurvey');
              }
              window.location.href = redirectUrl;
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "renderLogo", function () {
      var _this$props = _this.props,
        logo = _this$props.logo,
        noLogoLink = _this$props.noLogoLink,
        logoLinkTo = _this$props.logoLinkTo;
      if (noLogoLink) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "navbar-brand"
        }, logo);
      }
      if (logoLinkTo) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: logoLinkTo
        }, logo);
      }
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        className: "navbar-brand",
        to: "/"
      }, logo);
    });
    _defineProperty(_this, "openLogInModal", function (e) {
      e && e.preventDefault();
      _this.modalLogIn.open();
    });
    _defineProperty(_this, "openUpdateProfileModal", function (e) {
      e && e.preventDefault();
      _this.modalUpdateProfile.open();
    });
    _defineProperty(_this, "openChangePasswordModal", function (e) {
      e && e.preventDefault();
      _this.modalChangePassword.open();
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var menuItems = [];
      var returnToUserLink = null;
      if (Fortress.auth()) {
        var switchRoles = Fortress.user.pawns.filter(function (r) {
          return !['Guest', 'Respondent'].includes(r.name);
        });
        if (Fortress.user.loggedInAsAnotherUser) {
          returnToUserLink = /*#__PURE__*/_react["default"].createElement("li", {
            key: "returnToUserLink"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: this.returnToUser
          }, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], {
            spaceRight: true
          }), " Return to \"", Fortress.user.actualUsername, "\" user"));
        }
        if (Fortress.hasAccess('uber.admin')) {
          menuItems.push(/*#__PURE__*/_react["default"].createElement("li", {
            key: "legosAdmin",
            className: "dropdown"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            className: "dropdown-toggle",
            "data-toggle": "dropdown",
            role: "button",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, "Admin ", /*#__PURE__*/_react["default"].createElement("span", {
            className: "caret"
          })), /*#__PURE__*/_react["default"].createElement("ul", {
            className: "dropdown-menu"
          }, /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/appdefs/about"
          }, "About"), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/appdefs/logs"
          }, "Logs"), /*#__PURE__*/_react["default"].createElement("li", {
            role: "separator",
            className: "divider"
          }), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/quest"
          }, "Quests"), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/resources/admin"
          }, "Resources"), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/shorturls"
          }, "Short URLs"), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/products"
          }, "Products"), /*#__PURE__*/_react["default"].createElement("li", {
            role: "separator",
            className: "divider"
          }), /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
            to: "/appdefs/admin/json-editor"
          }, "App Settings"))));
        }
        if (this.props.allowSwitchRoles && !this.props.hideSeparateRoleSwitcher && !Fortress.user.loggedInAsAnotherUser && switchRoles.length > 1) {
          menuItems.push(/*#__PURE__*/_react["default"].createElement("li", {
            key: "switchProfile",
            className: "dropdown"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            className: "dropdown-toggle",
            "data-toggle": "dropdown",
            role: "button",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, Fortress.user.acting.label, " ", /*#__PURE__*/_react["default"].createElement("span", {
            className: "caret"
          })), /*#__PURE__*/_react["default"].createElement("ul", {
            className: "dropdown-menu"
          }, switchRoles.map(function (pawn) {
            return /*#__PURE__*/_react["default"].createElement("li", {
              key: pawn.id
            }, /*#__PURE__*/_react["default"].createElement("a", {
              href: "#",
              onClick: _this2.changeRole.bind(_this2, pawn.id)
            }, pawn.name, pawn.id === Fortress.user.pawnId && /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
              spaceLeft: true
            })));
          }))));
        }
        if (this.props.showAlerts) {
          menuItems.push(/*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.AlertButton, {
            alertLimit: this.props.alertLimit
          }));
        }
        menuItems.push(/*#__PURE__*/_react["default"].createElement("li", {
          key: "logout",
          className: "dropdown"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          className: "dropdown-toggle",
          "data-toggle": "dropdown",
          role: "button",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }, /*#__PURE__*/_react["default"].createElement(_user["default"], {
          spaceRight: true
        }), Fortress.user.username, " ", /*#__PURE__*/_react["default"].createElement("i", {
          className: "caret"
        })), /*#__PURE__*/_react["default"].createElement("ul", {
          className: "dropdown-menu"
        }, this.props.allowSwitchRoles && !Fortress.user.loggedInAsAnotherUser && switchRoles.map(function (pawn) {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: pawn.id
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "#",
            onClick: _this2.changeRole.bind(_this2, pawn.id)
          }, pawn.name, pawn.id === Fortress.user.pawnId && /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
            spaceLeft: true
          })));
        }), this.props.allowSwitchRoles && !Fortress.user.loggedInAsAnotherUser && /*#__PURE__*/_react["default"].createElement("li", {
          role: "separator",
          className: "divider"
        }), !Fortress.user.loggedInAsAnotherUser && Fortress.user.user.auth_type !== 'ldap' && [/*#__PURE__*/_react["default"].createElement("li", {
          key: "updateProfile"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: this.openUpdateProfileModal
        }, "Update Profile")), /*#__PURE__*/_react["default"].createElement("li", {
          key: "separator1",
          role: "separator",
          className: "divider"
        }), /*#__PURE__*/_react["default"].createElement("li", {
          key: "changePassword"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: this.openChangePasswordModal
        }, "Change Password")), /*#__PURE__*/_react["default"].createElement("li", {
          key: "separator2",
          role: "separator",
          className: "divider"
        })], /*#__PURE__*/_react["default"].createElement("li", {
          key: "logoutLink"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: Boilerplate.url('/api/user/logout')
        }, "Log out")))));
      } else {
        this.props.renderInModal ? menuItems.push(/*#__PURE__*/_react["default"].createElement("li", {
          key: "login"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: this.openLogInModal
        }, "Log In"))) : menuItems.push(/*#__PURE__*/_react["default"].createElement("li", {
          key: "login"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: Boilerplate.url('/account/login')
        }, "Log In")));
      }
      var renderLogo = this.renderLogo();
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: null,
        title: "Log in",
        size: "small",
        ref: function ref(elem) {
          _this2.modalLogIn = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.LoginForm, {
        formName: "topLoginForm"
      })), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: null,
        title: "Update Profile",
        ref: function ref(elem) {
          _this2.modalUpdateProfile = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.ProfileUpdateForm, {
        onSuccess: function onSuccess() {
          (0, _cccisdNotification["default"])('Profile has been updated');
          _this2.modalUpdateProfile.close();
        },
        pawnId: Fortress.user.pawnId,
        pawnHash: Fortress.user.actual.random_hash,
        includeUserFields: true,
        includePawnFields: true,
        includePasswordFields: false,
        showTheseProfileDataFields: this.props.showTheseProfileDataFields
      })), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: null,
        title: "Change Password",
        ref: function ref(elem) {
          _this2.modalChangePassword = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.ProfileUpdateForm, {
        onSuccess: function onSuccess() {
          (0, _cccisdNotification["default"])('Password has been successfully changed');
          _this2.modalChangePassword.close();
        },
        pawnId: Fortress.user.pawnId,
        pawnHash: Fortress.user.actual.random_hash,
        includeUserFields: false,
        includePawnFields: false,
        includeNotificationFields: false,
        includePasswordFields: true,
        buttonLabel: "Change Password"
      })), /*#__PURE__*/_react["default"].createElement("nav", {
        className: "navbar navbar-light"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.className
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "navbar-header"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "navbar-toggle collapsed",
        "data-toggle": "collapse",
        "data-target": "#main-navbar-collapse",
        "aria-expanded": "false"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Toggle navigation"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon-bar"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon-bar"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon-bar"
      })), renderLogo), /*#__PURE__*/_react["default"].createElement("div", {
        className: "collapse navbar-collapse",
        id: "main-navbar-collapse"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav navbar-nav navbar-right"
      }, returnToUserLink, this.props.children, this.props.showMenu && menuItems)))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  className: _propTypes["default"].string,
  logo: _propTypes["default"].node,
  children: _propTypes["default"].node,
  noLogoLink: _propTypes["default"].bool,
  showMenu: _propTypes["default"].bool,
  allowSwitchRoles: _propTypes["default"].bool,
  hideSeparateRoleSwitcher: _propTypes["default"].bool,
  showTheseProfileDataFields: _propTypes["default"].object,
  // array of data field handles to include in profile update
  renderInModal: _propTypes["default"].bool,
  logoLinkTo: _propTypes["default"].string,
  showAlerts: _propTypes["default"].bool,
  alertLimit: _propTypes["default"].number
});
_defineProperty(Component, "defaultProps", {
  className: 'container',
  logo: 'Logo',
  noLogoLink: false,
  showMenu: true,
  allowSwitchRoles: true,
  renderInModal: true,
  showAlerts: false
});